import styled from 'styled-components'
import { ReactComponent as Dots } from 'presentation/assets/icons/three-dots.svg'
import { MenuItem } from '@material-ui/core'

export const FiltersWrapper = styled.form`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
  margin-top: 32px;
  margin-bottom: 48px;
`

export const BoxDefaultCentered = styled.span`
  display: block;
  width: fit-content;
  text-align: center;
  margin: 0 auto;
  white-space: pre-wrap;
  word-wrap: break-word;
  line-height: 1.3;
`
export const DotsIcon = styled(Dots)`
  cursor: pointer;
  path {
    fill: #c0c0c0;
  }
`

export const StyledItem = styled(MenuItem)`
  color: ${({ theme }) => theme.colors.primary}!important;
  font-weight: ${({ theme }) => theme.font.bold}!important;
  border-radius: 8px !important;
  padding: 8px !important;
  margin-left: 8px !important;
  margin-right: 8px !important;

  span {
    margin-left: 8px;
  }

  circle {
    display: none;
  }

  svg,
  path {
    fill: ${({ theme }) => theme.colors.primary}!important;
  }

  &:hover {
    background-color: #e4f3e1 !important;
  }
`
